export const PAGE_DESCRIPTION = 'Find active commissions that you qualify for, based on your Merchant Memberships';
